import {FC} from 'react'
import {Redirect, RouteComponentProps} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {selectUser, selectUserProfile} from 'features/User'
import {DefaultLayout} from 'components'
import {LayoutProps} from 'components/Layouts/Layout.types'
import {RouteTransition} from './AnimatedRoutes'
import {SEOHelmet} from 'components/Basic/SEO'
import {Pathname} from 'interfaces/Routes.types'

export const PrivateRoute: FC<{
  component: FC<RouteComponentProps>
  authorizedRoles: string[]
  path: Pathname
  layout?: FC<LayoutProps>
  layoutProps?: {bgColor?: string; lgColumns?: string}
  exact?: boolean
}> = ({
  component: Component,
  authorizedRoles,
  layout: ComponentLayout,
  layoutProps,
  path,
  ...rest
}) => {
  const user = useSelector(selectUserProfile)
  const {role} = useSelector(selectUser)

  const Layout = ComponentLayout ?? DefaultLayout
  const layoutStyles = {
    lgColumns: layoutProps?.lgColumns ?? 'lg:grid-cols-4',
    bgColor: layoutProps?.bgColor ?? 'bg-white',
  }

  const renderPrivateComponent: FC<RouteComponentProps> = props => {
    if (!user?.token) {
      return (
        <Redirect
          to={{
            pathname: '/',
            state: {from: props.location.pathname},
          }}
        />
      )
    }

    if (authorizedRoles.includes(role)) {
      return (
        <Layout {...layoutStyles}>
          <SEOHelmet pathname={path} />
          <Component {...props} />
        </Layout>
      )
    }

    // when no access redirect to default screen
    return <Redirect to="/analytics/overview" />
  }
  return <RouteTransition {...rest} render={renderPrivateComponent} />
}
